import { createFeatureSelector, createSelector } from '@ngrx/store';

import { AppState } from './app.state';
import { AccountACL } from '../constants/account-acl.constants';
import { Account } from '../../core/models/account.model';

export const selectAppState = createFeatureSelector<AppState>('app');

export const selectCurrentUser = createSelector(selectAppState, (appState: AppState) => appState.currentUser);
export const userInfoPecPlus = createSelector(selectAppState, (appState: AppState) => appState.userInfoPecPlus);
export const clientTerzePartiGrants = createSelector(selectAppState, (appState: AppState) => appState.clientThirdPartsGrants);
export const otpDisplayAvailable = createSelector(selectAppState, (appState: AppState) => appState.otpDisplayAvailable);

export const userHasAnyACL = createSelector(selectCurrentUser, (user: Account | null, props: { acls: AccountACL | AccountACL[] }) => {
  if (!user || !user.acls) {
    return false;
  }
  if (!Array.isArray(props.acls)) {
    props.acls = [props.acls];
  }
  return user.acls.some((authority: AccountACL) => props.acls.includes(authority));
});

export const selectUserViewACL = createSelector(selectCurrentUser, (user: Account | null) => {
  if (!user || !user.acls) {
    return [];
  }
  return user.acls.filter(sAcl => sAcl.endsWith('VIEW'));
});
